import { render, staticRenderFns } from "./ResourceString.vue?vue&type=template&id=2502dc8c&scoped=true&"
import script from "./ResourceString.vue?vue&type=script&lang=js&"
export * from "./ResourceString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2502dc8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2502dc8c')) {
      api.createRecord('2502dc8c', component.options)
    } else {
      api.reload('2502dc8c', component.options)
    }
    module.hot.accept("./ResourceString.vue?vue&type=template&id=2502dc8c&scoped=true&", function () {
      api.rerender('2502dc8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/ResourceString.vue"
export default component.exports